import React, { useRef } from "react";
import './service.css';
import Coles from '../../assets/client1.png';
import Aldi from '../../assets/client2.png';
import Harrisfarm from '../../assets/client3.png';
import Woolworths from '../../assets/client4.png';
import emailjs from '@emailjs/browser';

const Service = () => {
    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm('service_qmort6u', 'template_r3pswhp', form.current, {
                publicKey: 'iKLeOkh2Cm5NGW4fj',
            })
            .then(
                () => {
                    console.log('SUCCESS!');
                    form.current.reset();
                },
                (error) => {
                    console.log('FAILED...', error.text);
                },
            );
    };
    return (
        <section id="contactPage">
            <div id="clients">
                <h1 className="contactPageTitle">My Clients</h1>
                <p className="clientDesc">
                    I have had the opportunity to work with a diverse group of companies.
                    Some of the notable companies I have worked with includes
                </p>
                <div className="clientImgs">
                    <img src={Coles} alt="Client" className="clientImg" />
                    <img src={Aldi} alt="Client" className="clientImg" />
                    <img src={Harrisfarm} alt="Client" className="clientImg" />
                    <img src={Woolworths} alt="Client" className="clientImg" />
                </div>
            </div>
            <div id="service">
                <h1 className="servicePageTitle">Contact Me</h1>
                <span className="serviceDesc">Please fill out the form below to discuss any work opportunities.</span>
                <form className="serviceForm" ref={form} onSubmit={sendEmail}>
                    <input type="text" className="name" placeholder="Your Name" name="your_name" />
                    <input type="email" className="email" placeholder="Your Email" name="your_email" />
                    <textarea className="msg" name="message" rows="5" placeholder="Your Message"></textarea>
                    <button type="submit" value="Send" className="submitBtn">Submit</button>
                </form>
            </div>
        </section>
    )
}

export default Service